import React from 'react';
import Select from './../Select';
import TextInput from "../TextInput";
import {CurrencyFormatter} from "../../../utils/formatters";
import PropsProxy from "../../layout/PropsProxy";

class ExternalShippingControl extends React.Component {

    setFieldValue = (field, value) => {
        this.props.saveChanges && this.props.saveChanges(field, value);
    }

    getProps = (name) => {
        let props = {};
        if (this.props.getFieldProps) {
            props = this.props.getFieldProps((this.props.name ? this.props.name + '.' : '') + name);
        }
        const disabled = this.props.disabled;//Array.isArray(this.props.disabled) ? this.props.disabled : [this.props.disabled];
        props.disabled = (!Array.isArray(disabled) && disabled) || (Array.isArray(disabled) && disabled.indexOf(name) !== -1);
        return props;
    }

    getFields = () => {
        return {
            ...this.props.fields,
            shipping_fee: <TextInput
                    type="number"
                    {...this.getProps("shipping_fee")}
                    name="shipping_fee"
                    label="Ár"
                    formatter={CurrencyFormatter}
                    className="currency"
                    value={this.props?.value?.shipping_fee}
                    saveChanges={(field, value) => this.setFieldValue(field, value || value + "" === "0" ? value : null)}
                />,
            vat: <Select
                    {...this.getProps("vat")}
                    name="vat"
                    required={this.props?.value?.shipping_fee > 0}
                    component="vatrate"
                    filter={{field: "active", value: 1}}
                    objectValue={true}
                    label="Áfa"
                    storeType="local"
                    value={this.props?.value?.vat}
                    view={["rate"]}
                    saveChanges={this.setFieldValue}
                />,
        }
    }

    render() {
        const fields = this.getFields();
        if (React.Children.count(this.props.children)) {
            return <PropsProxy fields={this.getFields()}>
                {this.props.children}
            </PropsProxy>
        } else {
            return <div className="col-md-12">
                <div className="row">
                    <div className="col-md-6 currency">
                        {fields.shipping_fee}
                    </div>
                    <div className="col-md-6">
                        {fields.vat}
                    </div>
                </div>
            </div>;
        }
    }

}

export default ExternalShippingControl;